/** Onde fica a página de Feriados e suspensões, e o que quem a abre pode passar. */
export const FERIADOS_PAGE = '/app/configuracoes/feriados';

/** O Calendário passa o próprio caminho: o "Voltar" da página leva de volta a ele. */
export interface FeriadosPageState {
  voltarPara?: string;
}
